import React from 'react';

export default function SeoJsonLd({ data, id }) {
  if (!data) return null;
  const payload = Array.isArray(data) ? data : [data];

  return payload.map((entry, index) => (
    <script
      key={`${id || 'seo-jsonld'}-${index}`}
      id={index === 0 ? id : undefined}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(entry) }}
    />
  ));
}
